export default function resolveURLSlash(
  host: string | undefined,
  path: string
) {
  if (!host) throw new ReferenceError(`'host' is undefined`);

  const lastCharOfHost = host[host.length - 1];
  const firstCharOfPath = path[0];

  if (lastCharOfHost === '/' && firstCharOfPath === '/') {
    return host + path.slice(1);
  }
  if (lastCharOfHost !== '/' && firstCharOfPath !== '/') {
    return host + '/' + path;
  }
  return host + path;
}
